import { CATEGORIE_DIVERS, CATEGORIE_LOCATION } from '@/configuration/catalogue/produitConf';
import i18n from '@/i18n';

export default function sortLigneByType(lignesCommande, typeProduitSelected) {
  const tlpe = [];
  const location = [];
  const divers = [];

  [
    ...new Set(lignesCommande
      .filter((el) => { return el.produitId; })
      .map((el) => el.produitId)),
  ].forEach((id) => {
    const ligneWithProduit = lignesCommande.find((el) => { return el.produitId === id; });
    const typeProduitInformation = {
      isSubTitle: false,
      produitId: ligneWithProduit.produitId,
      libelle: ligneWithProduit.libelle,
    };
    const ligneAlreadySelected = typeProduitSelected.find((el) => {
      return el.produitId === typeProduitInformation.produitId;
    });
    if (ligneAlreadySelected) return;
    if (ligneWithProduit.typeProduit === CATEGORIE_DIVERS) {
      if (ligneWithProduit.produit.produitDivers.tlpe) tlpe.push(typeProduitInformation);
      else divers.push(typeProduitInformation);
    }
    if (ligneWithProduit.typeProduit === CATEGORIE_LOCATION) location.push(typeProduitInformation);
  });

  let sortedTypeLigneCommande = [];
  if (!typeProduitSelected.find((el) => { return el.produitId === null && !el.isSubTitle; })) {
    sortedTypeLigneCommande.unshift({
      produitId: null,
      isSubTitle: false,
      libelle: i18n.t('editionRemise.allProduct'),
    });
  }
  if (location.length > 0) {
    sortedTypeLigneCommande.push({ isSubTitle: true, title: 'editionRemise.typeLigne.location', produitId: null });
    sortedTypeLigneCommande = sortedTypeLigneCommande.concat(location);
  }
  if (divers.length > 0) {
    sortedTypeLigneCommande.push({ isSubTitle: true, title: 'editionRemise.typeLigne.divers', produitId: null });
    sortedTypeLigneCommande = sortedTypeLigneCommande.concat(divers);
  }
  if (tlpe.length > 0) {
    sortedTypeLigneCommande.push({ isSubTitle: true, title: 'editionRemise.typeLigne.tlpe', produitId: null });
    sortedTypeLigneCommande = sortedTypeLigneCommande.concat(tlpe);
  }
  return sortedTypeLigneCommande;
}
